import { UPDATE_COMMON_COMPONENT_RESPONSE } from "../actions/commonComponentAction";

const initialState = {};

const commonCompReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_COMMON_COMPONENT_RESPONSE: {
      const { option, questionKey, questionText, response } = action.payload;

      return {
        ...state,
        [option]: {
          ...(state[option] || {}),
          [questionKey]: {
            question: questionText,
            response: response,
          },
        },
      };
    }
    default:
      return state;
  }
};

export default commonCompReducer;